function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import MapDrawComponent from '../../components/Map/MapDraw';
import { useSelector } from 'react-redux';
function MapDraw(props) {
  var _useSelector = useSelector(function (state) {
      var _state$app, _state$app$project;
      return (state === null || state === void 0 ? void 0 : (_state$app = state.app) === null || _state$app === void 0 ? void 0 : (_state$app$project = _state$app.project) === null || _state$app$project === void 0 ? void 0 : _state$app$project.configs) || {};
    }),
    showPolygonSwitch = _useSelector.showPolygonSwitch;
  var _useSelector2 = useSelector(function (state) {
      var _state$app2;
      return (state === null || state === void 0 ? void 0 : (_state$app2 = state.app) === null || _state$app2 === void 0 ? void 0 : _state$app2.map) || {};
    }),
    draw = _useSelector2.draw;
  return /*#__PURE__*/React.createElement(MapDrawComponent, _extends({
    showPolygonSwitch: showPolygonSwitch,
    draw: draw
  }, props));
}
export default MapDraw;